import { Direction } from '@/gql/graphql';

export function toDirection(value: 'asc' | 'desc') {
    if (value === 'asc') {
        return Direction.ASC;
    }

    return Direction.DESC;
}
